import { showBootError } from "./lib/bootError";
import { isElectron } from "./env";
import { prepareTiputiniAccountScope, watchTiputiniAccountChanges } from "./tiputini/accountScope";

// Bundled dev can move UI code into shared chunks. Load it only after this
// entry runs the React refresh preamble, and catch failures before React mounts.
const prepareStartup =
  import.meta.env.VITE_TIPUTINI === "true" && !isElectron
    ? prepareTiputiniAccountScope().then(() => watchTiputiniAccountChanges())
    : Promise.resolve();

void prepareStartup
  .then(() => import("./main"))
  .then(({ startup }) => startup)
  .catch(showBootError);
